import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import { FoodContext } from "../../../../contexts/Food";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import { ToastError } from "../../../../functions/ToastShow";

const SalesAnalysisReport = () => {

  const { t } = useTranslation();
  //getting context values here

  let { loading, setLoading, dataPaginating, generalSettings } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);
  let { branchForSearch } = useContext(RestaurantContext);
  const { foodGroupForSearch } = useContext(FoodContext);
  let [newStockReport, setNewStockReport] = useState(null);

  //all data
  const [reportData, setReportData] = useState(null);
  const [detailReportData, setDetailReportData] = useState(null);

  const componentRef = useRef();
  const componentRef1 = useRef();
  const componentRef1Thermal = useRef();
  //settle order
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [option, setOption] = useState("excel");
  const [generatedReport, setGeneratedReport] = useState(false);
  const [generatedDetailReport, setGeneratedDetailReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  //useEffect == componentDidMount()

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  const handleBranch = (branch) => {
    setNewStockReport({
      ...newStockReport,
      branch,
    });
  };

  const handleCategory = (categories) => {
    setNewStockReport({
      ...newStockReport,
      categories,
    });
  };

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const thermalPrint = useReactToPrint({
    content: () => componentRef1Thermal.current,
    pageStyle: `@page { margin: 10px;}`,
  });

  const handleDealType = (dealType) => {
    setNewStockReport({
      ...newStockReport,
      dealType,
    });
  };

  //get BranchWise reports filter
  const getBranchWiseSelected = (e) => {
    e.preventDefault();
    setReportData(null);
    setGeneratedReport(false);
    setDetailReportData(null);
    setGeneratedDetailReport(false);
    console.log("newStockReport ", newStockReport);
    if (
      (authUserInfo.details.user_type === "staff" ||
        authUserInfo.details.user_type === "manager") &&
      !newStockReport?.branch?.[0]?.id
    ) {
      ToastError({ title: _t(t("Please select Branch to generate report")) });
      return;
    }
    if (
      // newStockReport?.branch?.id !== null &&
      startDate !== null &&
      endDate !== null
    ) {
      setLoading(true);
      const from_date = moment(startDate).format("YYYY-MM-DD");
      const to_date = moment(endDate).format("YYYY-MM-DD");
      // backward-compatible month key (some APIs still expect it)
      const date = moment(startDate).format("YYYY-MM");

      const url = BASE_URL + "/settings/get-item-monthly-stock-report";
      const branch =
        newStockReport?.branch && newStockReport?.branch?.length
          ? JSON.stringify(newStockReport?.branch.map((branch) => branch.id))
          : "";
      const categories =
        newStockReport?.categories && newStockReport?.categories?.length
          ? JSON.stringify(newStockReport?.categories.map((c) => c.name || c.value || c))
          : "";
      const dealType = newStockReport?.dealType || "non_deal";

      let formData = new FormData();
      formData.append("date", date);
      formData.append("from_date", from_date);
      formData.append("to_date", to_date);
      formData.append("branch_id", branch);
      formData.append("category", categories);
      formData.append("type", dealType);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setReportData(res.data);

          setLoading(false);
          setGeneratedReport(true);
          setTimeout(() => {
            if (componentRef.current) {
              componentRef.current.handleDownload();
            }
          }, 100);
          setNewStockReport(null);
        })
        .catch((error) => {
          setLoading(false);
          if(error.response?.data?.status === 0){
            ToastError({ title: _t(t(error.response.data.message)) });
            return
          }
        });
    } else {
      ToastError({ title: _t(t("Please select from date and to date and generate report")) });
    }
  };

  const getDetailReport = (e) => {
    e.preventDefault();
    setReportData(null);
    setGeneratedReport(false);
    setDetailReportData(null);
      setGeneratedDetailReport(false);

      if (
        (authUserInfo.details.user_type === "staff" ||
          authUserInfo.details.user_type === "manager") &&
        !newStockReport?.branch?.[0]?.id
      ) {
        ToastError({ title: _t(t("Please select Branch to generate report")) });
        return;
      }
      if (startDate !== null && endDate !== null) {
        setLoading(true);
        const from_date = moment(startDate).format("YYYY-MM-DD");
        const to_date = moment(endDate).format("YYYY-MM-DD");

        const url = BASE_URL + "/settings/get-sale-analysis-report";
        const branch =
          newStockReport?.branch && newStockReport?.branch?.length
            ? JSON.stringify(newStockReport?.branch.map((branch) => branch.id))
            : "";

        let formData = new FormData();
        formData.append("from_date", from_date);
        formData.append("to_date", to_date);
        formData.append("branch_id", branch);

        return axios
          .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setDetailReportData(res.data);
          setLoading(false);
          setGeneratedDetailReport(true);
          setTimeout(() => {
            if (option === "excel") {
              if (componentRef1.current) {
                componentRef1.current.handleDownload();
              }
            } else {
              thermalPrint();
            }
          }, 100);
          setNewStockReport(null);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response?.data?.status === 0) {
            ToastError({ title: _t(t(error.response?.data?.message)) });
            return;
          }
        });
    } else {
      ToastError({ title: _t(t("Please select from date and to date and generate report")) });
    }
  };

  let grandTotals = {
    total_qty: 0,
    total_amount: 0,
    total_discount: 0,
    no_of_orders: 0,
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Sales Analysis Report"))}</title>
      </Helmet>

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Sales Analysis Report"
        sheet="sheet 1"
        buttonText="Sales Detail"
        ref={componentRef}
      />

      <ReactHTMLTableToExcel
        id="detail-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="detail-to-xls"
        filename="Sales Analysis Detail Report"
        sheet="sheet 1"
        buttonText="Sales Detail"
        ref={componentRef1}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan={(reportData?.dates?.length * 2) + 3} style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Sales Analysis Report
                                        </h3>
                                        <p className="text-center">
                                          Date: From <Moment format="LL">
                                            {startDate}
                                          </Moment> to <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th scope="col">{_t(t("Branch"))}</th>
                                  <th scope="col">{_t(t("Group"))}</th>
                                  <th scope="col">{_t(t("Product"))}</th>
                                  <th scope="col" colSpan={2}>{_t(t("Total"))}</th>

                                  {reportData?.dates?.map((date, index) => (
                                    <th
                                      colSpan={2}
                                      className="sm-text text-capitalize align-middle text-center border-1 border"
                                      key={index}
                                    >
                                      {date}
                                    </th>
                                  ))}
                                </tr>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    QTY
                                  </th>
                                  <th
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    Value
                                  </th>
                                  {reportData?.dates?.map((_, index) => (
                                    <React.Fragment key={index}>
                                      <th
                                        className="sm-text text-capitalize align-middle text-center border-1 border"
                                        key={index}
                                      >
                                        QTY
                                      </th>
                                      <th
                                        className="sm-text text-capitalize align-middle text-center border-1 border"
                                        key={index}
                                      >
                                        Value
                                      </th>
                                    </React.Fragment>
                                  ))}
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {reportData?.data &&
                                  Object.keys(reportData.data)?.length &&
                                  Object.keys(reportData.data).map((group) => {
                                    return (
                                      <>
                                        <tr>
                                          <th>{group}</th>
                                        </tr>
                                        {reportData.data[group] && Object.keys(reportData.data[group])?.length &&
                                          Object.keys(reportData.data[group]).map((groupItem) => {
                                            return (
                                              <>
                                                <tr>
                                                  <td></td>
                                                  <td><strong>{groupItem}</strong></td>
                                                </tr>
                                                {reportData.data[group][groupItem] && reportData.data[group][groupItem]?.length &&
                                                  reportData.data[group][groupItem].map((item, i) => {
                                                    const totalQty = (reportData?.dates || []).reduce((sum, date) => {
                                                      const qty = Number(item?.[date]?.qty ?? 0);
                                                      return sum + (Number.isFinite(qty) ? qty : 0);
                                                    }, 0);
                                                    const totalValue = (reportData?.dates || []).reduce((sum, date) => {
                                                      const value = Number(item?.[date]?.price ?? 0);
                                                      return sum + (Number.isFinite(value) ? value : 0);
                                                    }, 0);

                                                    return (
                                                      <tr key={i}>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{item.item_name}</td>
                                                        <td><strong>{totalQty}</strong></td>
                                                        <td><strong>{totalValue}</strong></td>
                                                        {reportData?.dates?.map((date) => (
                                                          <>
                                                            <td>{item[date]?.qty ?? 0}</td>
                                                            <td>{item[date]?.price ?? 0}</td>
                                                          </>
                                                        ))}
                                                      </tr>
                                                    );
                                                  }
                                                )}
                                              </>
                                            )
                                          })
                                        }
                                        <tr></tr>
                                      </>
                                    );
                                  })}
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="7"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}

                  {detailReportData !== null &&
                    detailReportData !== undefined &&
                    generatedDetailReport === true && (
                      <div ref={componentRef1Thermal} className="fk-print w-100">
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="detail-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colSpan="10" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Detail Sales Analysis Report
                                        </h3>
                                        <p className="text-center">
                                          Date: From <Moment format="LL">
                                            {startDate}
                                          </Moment> to <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th scope="col" className="border-1 border">{_t(t("Branch"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("Food Group"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("Barcode"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("Food Item Name"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("Total Qty"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("Average Rate"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("Total Amount"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("Total Discount"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("Discount Percentage"))}</th>
                                  <th scope="col" className="border-1 border">{_t(t("No of Orders"))}</th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {Object.keys(detailReportData).map((branchName, bIndex) => {
                                    let branchData = detailReportData[branchName];
                                    return (
                                      <React.Fragment key={bIndex}>
                                        <tr>
                                          <th colSpan="10">{branchName}</th>
                                        </tr>
                                        {Object.keys(branchData).map((groupName, gIndex) => {
                                          let groupItems = branchData[groupName];
                                          let groupTotals = {
                                            total_qty: 0,
                                            total_amount: 0,
                                            total_discount: 0,
                                            no_of_orders: 0,
                                          };

                                          return (
                                            <React.Fragment key={`${bIndex}-${gIndex}`}>
                                              <tr>
                                                <td></td>
                                                <td colSpan="9"><strong>{groupName}</strong></td>
                                              </tr>
                                              {groupItems.map((item, iIndex) => {
                                                groupTotals.total_qty += Number(item.total_qty || 0);
                                                groupTotals.total_amount += Number(item.total_amount || 0);
                                                groupTotals.total_discount += Number(item.total_discount || 0);
                                                groupTotals.no_of_orders += Number(item.no_of_orders || 0);

                                                grandTotals.total_qty += Number(item.total_qty || 0);
                                                grandTotals.total_amount += Number(item.total_amount || 0);
                                                grandTotals.total_discount += Number(item.total_discount || 0);
                                                grandTotals.no_of_orders += Number(item.no_of_orders || 0);

                                                return (
                                                  <tr key={iIndex}>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{item.barcode}</td>
                                                    <td>{item.food_item_name}</td>
                                                    <td>{item.total_qty}</td>
                                                    <td>{Number(item.average_rate || 0).toFixed(3)}</td>
                                                    <td>{Number(item.total_amount || 0).toFixed(3)}</td>
                                                    <td>{Number(item.total_discount || 0).toFixed(3)}</td>
                                                    <td>{Number(item.discount_percentage || 0).toFixed(2)}</td>
                                                    <td>{item.no_of_orders}</td>
                                                  </tr>
                                                );
                                              })}
                                              <tr>
                                                <th colSpan="4" className="text-right">Group Total</th>
                                                <th>{groupTotals.total_qty}</th>
                                                <th></th>
                                                <th>{groupTotals.total_amount.toFixed(3)}</th>
                                                <th>{groupTotals.total_discount.toFixed(3)}</th>
                                                <th>{groupTotals.total_amount ? ((groupTotals.total_discount / groupTotals.total_amount) * 100).toFixed(2) : 0}</th>
                                                <th>{groupTotals.no_of_orders}</th>
                                              </tr>
                                            </React.Fragment>
                                          );
                                        })}
                                      </React.Fragment>
                                    );
                                   })
                                }
                                
                                <tr>
                                  <th colSpan="4" className="text-right">Grand Total</th>
                                  <th>{grandTotals.total_qty}</th>
                                  <th></th>
                                  <th>{grandTotals.total_amount.toFixed(3)}</th>
                                  <th>{grandTotals.total_discount.toFixed(3)}</th>
                                  <th>{grandTotals.total_amount ? ((grandTotals.total_discount / grandTotals.total_amount) * 100).toFixed(2) : 0}</th>
                                  <th>{grandTotals.no_of_orders}</th>
                                </tr>
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colSpan="10"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    <CustomSpinLoader loading={loading || dataPaginating} />
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-12 t-mb-15 mb-md-0 d-flex justify-content-between">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Sales Analysis Report"))}
                              </span>
                            </li>
                          </ul>
                          <div>
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row g-2 mt-2 align-items-end">
                        <div className="col-12 col-md-6 col-lg-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="dd/MM/yyyy"
                            dropdownMode="select"
                            className="form-control t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-2">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            dateFormat="dd/MM/yyyy"
                            dropdownMode="select"
                            className="form-control t-mb-15 mb-md-0"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 t-mb-15 mb-md-0">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isMulti
                            isClearable
                            value={newStockReport?.branch || ""}
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 t-mb-15 mb-md-0">
                          <Select
                            options={foodGroupForSearch ? foodGroupForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isMulti
                            isClearable
                            value={newStockReport?.categories || ""}
                            onChange={handleCategory}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select category")) + ".."}
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-2 t-mb-15 mb-md-0">
                          <div className="d-flex flex-wrap align-items-center gap-3">
                            <div className="form-check form-check-inline mb-0">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="month_stock_deal"
                                name="month_stock_deal_type"
                                value="deal"
                                checked={(newStockReport?.dealType || "non_deal") === "deal"}
                                onChange={(e) => handleDealType(e.target.value)}
                              />
                              <label
                                className="form-check-label pointer-cursor text-primary"
                                htmlFor="month_stock_deal"
                                style={{ fontSize: "14px" }}
                              >
                                {_t(t("Deal"))}
                              </label>
                            </div>
                            <div className="form-check form-check-inline mb-0">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="month_stock_non_deal"
                                name="month_stock_deal_type"
                                value="non_deal"
                                checked={(newStockReport?.dealType || "non_deal") === "non_deal"}
                                onChange={(e) => handleDealType(e.target.value)}
                              />
                              <label
                                className="form-check-label pointer-cursor text-primary"
                                htmlFor="month_stock_non_deal"
                                style={{ fontSize: "14px" }}
                              >
                                {_t(t("Non Deal"))}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 mt-2 t-mb-15 mb-md-0 text-right d-flex justify-content-end">
                          <button
                            className="btn btn-primary text-uppercase sm-text py-2 rounded mr-2"
                            onClick={(e) => getBranchWiseSelected(e)}
                          >
                            Generate Report
                          </button>
                          <button
                            className="btn btn-success text-uppercase sm-text py-2 rounded"
                            onClick={(e) => getDetailReport(e)}
                          >
                            Detail Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default SalesAnalysisReport;
